import { j as o } from "./jsx-runtime-721af1ab.js";
import { B as s } from "./cleave-react-node-3145b543.js";
import { a, u, i as c, g as i } from "./useAccount-5ddee56a.js";
import "react";
import "./features-e6661c21.js";
import { D as v, e as C } from "./eMyAsurionProvider-f4427540.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/react";
import "@tanstack/react-query";
import "@chakra-ui/icons";
import "./providers-a757499d.js";
import "@emotion/react";
import "./lodash-3345fe65.js";
import "@emotion/styled";
import "./domains-5b6d38aa.js";
import "react-router-dom";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "@react-oauth/google";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-ce0111a3.js";
import "./myasurion-shared.profile.es.js";
import "mixpanel-browser";
const $ = ({
  headerComponent: e,
  bypass: t = !1,
  children: m
}) => {
  const [p] = a({ profileId: "", userId: "" }), [n] = u({ authorization: "", token: "", id: "" }), r = c(p, n);
  return t || r || (console.log(`Unauthorized user redirecting to ${i("/login")}`), window.location.href = i("login")), /* @__PURE__ */ o.jsx(o.Fragment, { children: (t || r) && /* @__PURE__ */ o.jsxs(s, { id: "myasurion-protected-layout", children: [
    e,
    m
  ] }) });
};
export {
  v as DesktopView,
  C as MobileView,
  $ as ProtectedLayout
};
